import React, { ReactChildren, ReactNode } from 'react';
import { Button, Col, Row } from 'antd';
import { useHistory } from 'react-router';
import UnAuthorizedIcon from '../../../assets/icons/unauthorized.svg';
import { MENU_ITEMS } from './Sidebar/SidebarConstants';
import { IApplicationState, useAppSelector } from '../../../libs/store/reducers';
import { IUserPermission } from '../../../libs/models/UserModels';
import { routes } from '../../../navigation/Routes';

interface IRouteGuardProp {
  children: ReactNode;
}
const RouteGuard = ({ children }: IRouteGuardProp) => {
  const history = useHistory();
  const pathName = window.location.pathname;
  const permission = MENU_ITEMS.find((item) => item.path === pathName)?.permission;
  const { userDetails } = useAppSelector(({ user: { userDetails } }: IApplicationState) => ({
    userDetails,
  }));
  const isAllowed = permission
    ? permission in (userDetails?.user_permissions || {}) &&
      userDetails?.user_permissions[permission as keyof IUserPermission]
    : true;
  if (isAllowed) {
    return <>{children}</>;
  }
  return (
    <div className="dashboard-container">
      <Row>
        <Col span={24} className="flex-center color-danger flex-column">
          <img src={UnAuthorizedIcon} className="unauthorized-icon" alt="unauthorized icon" />
          <h1 className="unauthrized-header mt-1">Unauthorized!</h1>
          <p> User is not allowed to view this screen.</p>
          <Button type="primary" onClick={()=>{
            history.push(routes.dashboard)
          }} className='back-btn'>Go Back</Button>
        </Col>
      </Row>
    </div>
  );
};

export default RouteGuard;
